/**
 * TODO: Change naming conventions to be A...B / captial instead of camel case
 */

export const dimGray = '#707070';
export const grayShade1 = '#f1f1f1';
export const darkGray = '#A2A2A2';
export const darkGray2 = '#323232';
export const darkGrayRGBA = (a) => `rgba(162,162,162,${a || '1'})`;
export const gray = '#afb4be';
export const raisinBlack = '#222222';

export const white = '#FFFFFF';
export const whiteRGBA = (a) => `rgba(255,255,255,${a || 1})`;

export const Black = '#000000';
export const blackRGBA = (a) => `rgba(0,0,0,${a || 1})`;

export const Warning = '#FFAA00';
export const DarkOrange = '#ff8c00';

export const skyBlue = `rgba(66, 133, 244, 0.2)`;
/**
 * TODO: Remove this
 */
export const black = '#000000';
export const shadow = '#3c4043';

const brightPink = '#E80CD6';

// Editor Test Styles:
export const HeadingFG = '#333d47';
export const ContentFG = '#24292e';
export const ContentAltFG = '#6c718b';
export const AlertBG = '#F2C94C';
export const BannerBG = '#ECEB98';

// Brandbook Guidelines can be found at https://app.nuclino.com/Wisedoc/Developer-Documents/Brandbook-a7375e31-a516-4d21-95d8-7252d69598e0
export const PrimaryDark = '#473880';
export const PrimaryDarkRGBA = (a) => `rgba(71,56,128,${a || 1})`;
export const PrimaryMedium = '#8510df';
export const PrimaryLight = '#c736ff';
export const ElectricIndigoHex = '#8829ff';
export const ElectricIndigoDarkHex = '#670adb';

// These colors were generated by Adobe Color CC (https://color.adobe.com/) based on our primary medium color
export const SecondaryDark = '#33045A';
export const SecondaryLight = '#9F2BCC';
export const SecondaryMedium = '#8410de';

export const Limegreen = '#32CD32';
export const DarkRed = '#a81111';
export const MediumLightCyanBlue = '#abc';
export const DangerRed = '#dc3545';

// DELETE COLOR
export const Delete = '#7D7D7D';

// DELETE COLOR
export const AddColor = '#7D7D7D';

// separators
export const mainSeparator = (a) => `rgba(60,64,67,${a || 1})`;

/**
 * Foreground
 */
export const ScrollbarForeground = '#9c94b8'; // only used in mozilla

/**
 * background colors
 * TODO: need to change
 */
export const Gray94 = '#f0f0f0';
export const EditorBackground = '#F8F9FA';
export const ExtremeLightGray = '#FEFEFE';
export const ScrollBarBackground = '#f1f1f1'; // only being used in mozilla

// landing page colors
export const FeaturesBenefitsBG = '#E4FFEE';
export const HowItWorksBG = '#f4f4ff';
export const ExploreBG = '#eaf9ff';
export const GreenTint = '#c9e3d0';

// These were used in legacy wisedoc application
export default {
  darkModerateBlue: '#373277',
  veryDarkBlue: '#13354f',
  veryDarkDesaturatedBlue: '#232f3e',
  veryDarkSaturatedBlue: '#495572',
  brightPink,
  white,
  black,
  grayishBlue: '#bebcd8',
  paleBlue: '#9fd8ff',
  lightGrayishRed: '#f1eeee',
  lightOrange: '#ff9f55',
  warningColor: '#F0AD4E',
  lightGray: '#EEEEEE',
  shadow,
  gray,
  darkGray,
  primaryButtonColor: PrimaryLight,
  primaryButtonColorHover: '#C736E8', // Offset primary light
  silver: '#c0c0c0',
  palmLeaf: 'rgba(46, 43, 62, 0.87)',
  fog: '#d8d7da',
  paynesGrey: '#404041',
  whiteSmoke: '#f3f2f2',
  green: '#008000',
  red: '#FF0000',
  grey: '#7b7b7b',
  cyanBlue: '#007BFF',
};

// Drive css colors
export const DropdownBorder = '0px solid #e0e0e0';
export const DropdownBoxShadow = 'rgb(177 186 190) 0px 0px 8px';
export const PathHoverBg = 'rgba(162, 162, 162, 0.16)';
export const DriveHeadBoxShadow = '0 1px 0 rgba(160, 160, 160, 0.16)';
export const TitleColor = '#5f6368';
export const PaleGrayHex = '#f6f6f6';
export const lightGray2 = '#e5e5e5';
export const lightGrayRgb = (a) => `rgba(229, 229, 229, ${a || 1})`;
export const GrayBorder = `1px solid ${lightGray2}`;

// New-Homepage HowToWriteResume colors
export const imgBorderColor = '#acb3ba';

// New-Homepage WantAGreatPage colors
export const backgroundColor =
  'linear-gradient(96.3deg, #6474e5 0%, #9aa4ec 100%);';
export const buttonColor = '#6474e5';

// New-homepage-whyWisedoc colors
export const HeadingBlue = '#122241';
export const HomepageText = '#4A4A4A';

// Job Description Popup
export const saveBgColor = '#219653';
export const saveHoverColor = '#1f8d4e';

// Tetra
export const warningFillColor = '#ffc107';

export const CommentBGColor = '#e5c72b';
export const LightShadeGray = '#cbcbcb';
// download popup colors

export const hireBtnText = '#219653';
export const laterBtnShadow = 'rgba(33, 33, 33, 0.2)';
export const loaderColor = 'linear-gradient(180deg, #8510df 0%, #473880 100%)';

export const navViolet = '#670adb';
// showTemplate colors
export const grayChipBG = 'rgba(224, 224, 224, 0.68)';
export const greenChipBG = '#e0ffd8';
export const mutsIcon = '#3f3f3f';
export const carminePink = '#e64845';
export const denim = '#1b5ebe';
export const turquoiseGreen = '#A3DFB3';

// template gallery chip
export const msWordChipBG = '#2B57A8';
export const atsChipBG = '#E0FFD8';

export const shadePurple = '#b48fc7';

// Tetra colors
export const redTextColor = '#EA4335';
export const greenTextColor = '#34A853';
export const chipBgColor = '#f7f7f7';
export const borderColor = '#f2f2f2';

// Loader Animation
export const contactCardBg = 'rgb(252, 236, 243)';
export const contactCardBorder = 'rgb(210, 175, 211)';
export const avatarBg = 'rgb(153, 106, 169)';
export const glassInnerColor = 'rgb(111, 197, 211)';
export const glassInnerBg = 'rgb(167, 217, 225)';
export const handleBg = 'rgb(95, 168, 180)';
export const contentBg = '#7a2d92';
export const BlueBgColor = 'rgb(229, 235, 247)';

export const HigherEdBorder = '#e2e4f0';

// J_Stoll
export const textGray = 'rgba(34, 34, 34, 0.80)';

// IRIS
export const appSubmissionConfirmBtn = '#3085d6';
export const appSubmissionCancelBtn = '#6ea9e2';

// Drive
export const darkGrayIconFill = '#03000A';
export const smokeGray = '#444746';
export const translucentGray = 'rgba(95, 99, 104, 0.08)';
export const lightBlue = '#DFE9FF';
export const pastelBlue = '#e7efff';
export const featherGray = '#f7f9fc';
export const RaisinBlack = '#222';
export const Platinum = '#e8e8e8';
export const AliceBlue = '#f2f6fc';
export const QuickSilver = '#A1A1AA';
export const BrightGray = '#e9eef6';
export const Sapphire = '#0b57d0';
export const GraniteGray = '#5f6368';

// Banner
export const bahamaBlue = '#252731';
export const lightShadowBlue = '#e1e3eb';
export const peacoat = '#323543';
export const peacoat2 = '#3c3e4d';
export const blackShades = '#2e303d';
export const TaupeGray = '#878787';

export const SemiTransparentDarkSlateBlue = `rgba(71, 56, 128, 0.3)`;

// IRIS
export const GhostWhite = '#f9f9f9';
export const starGold = '#FFD700';
export const starOrange = '#FFA500';
export const starRed = '#FF0000';
export const done = '#34a853';
export const cancelled = '#ff0000';
export const rejected = '#ffa500';
export const avatarBgColor = '#00000030';
export const taskBoardBlue = '#4660f9';
export const chipBackground = '#fcfcfc';

export const blackShadowActivity = '#00000016';
export const activityListingMetrics = '#a3a5b7';
export const BrandeisBlue = '#0D6EFD';
export const AddButtonColor = 'rgba(125, 125, 125, 1)';
export const boxShadow = '0px 0px 0px 1px rgba(162, 162, 162, 0.2)';

export const SonicSilver = '#71717a';
export const TipsHeadingColor = '#4155b4';

export const Arsenic = 'rgba(59, 69, 78, 1)';

// colors for coming soon page

export const RhinoGray = '#70727e';
export const CharcoalGray = '#4e4f58';
export const ShadowStyle = '0px 5px 20px 0px';
export const FoggyGray = 'rgba(100, 100, 111, 0.3)';
export const FoggyGrayShadow = `${FoggyGray} ${ShadowStyle}`;

// colors for apps page
export const Bluish = '#2980B9';
export const ResumeCardGradient =
  'linear-gradient(-103.597deg, rgba(41, 128, 185, 30%) 23%, rgba(109, 213, 250, 30%) 61%, rgba(255, 255, 255, 30%) 100%)';
export const CoverLetterCardGradient =
  'linear-gradient(-103.597deg, rgba(0, 201, 255, 30%) 0%, rgba(146, 254, 157, 30%) 100%)';
export const LinkedInCardGradient =
  'linear-gradient(-103.514deg, rgba(236, 233, 230, 40%) 0%, rgba(255, 255, 255, 40%) 100%)';
export const BoxShadowColor = 'rgba(0, 0, 0, 0.25)';
export const ButtonBorderGradientColor =
  'linear-gradient(90deg, #2980B9, #6DD5FA)';
export const CoverLetterBorderGradientColor =
  'linear-gradient(90deg, #00C9FF, #92FE9D)';

export const StartCommandBlue = '#0077b5';
export const DesertStorm = '#ECE9E6';
export const LinkedinBg = '#0a66c2';
export const MirageGradient = '#22222280';
export const GenerateWithAIColor =
  'linear-gradient(to right, #473880, #8510df)';
export const AIJobSearchGradient =
  'linear-gradient(to left, rgba(0, 0, 70, 0.25), rgba(109, 213, 250, 0.25) 55%, rgba(29, 38, 113, 0.25))';
export const BrandeisBlues = '#0070f0';
